module.exports = __webpack_public_path__ + "img/letter.82b44267.svg";